import {
    SkyDataGridColumnDefinition,
    SkyNetDataGridFilterType,
} from 'app/shared-components/SkyBaseDataGrid/SkyBaseDataGrid.types'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    LaneGroup,
} from 'app/Apps/Pricing/Pricing.types'
import {
    CollectionServiceType,
    DeliveryServiceType, LeaseType,
} from 'app/enums/label.enums'

const config: SkyDataGridColumnDefinition<LaneGroup>[] = [
    {
        name: 'laneGroupNumber',
        labelKey: 'LANE_GROUP',
    },
    {
        name: 'deliveryServiceType',
        componentName: 'EnumValue',
        allowedValuesEnum: DeliveryServiceType,
        filterType: FilterType.Array,
        labelKey: 'DELIVERY_SERVICE_TYPE',
    },
    {
        name: 'handoverPointLocationName',
        filterType: FilterType.Array,
        labelKey: 'HANDOVER_POINT',
    },
    {
        name: 'collectionServiceType',
        filterType: FilterType.Array,
        componentName: 'EnumValue',
        allowedValuesEnum: CollectionServiceType,
        labelKey: 'COLLECTION_SERVICE_TYPE',
    },
    {
        name: 'collectionDropoffPointLocationName',
        filterType: FilterType.Array,
        labelKey: 'COLLECTION_POINT',
    },
    {
        name: 'leaseType',
        filterType: FilterType.Array,
        componentName: 'EnumValue',
        allowedValuesEnum: LeaseType,
        labelKey: 'LEASE_TYPE',
    },
    {
        name: 'originAirportsIataCode',
        filterType: FilterType.Array,
        componentName: 'List',
        labelKey: 'FROM',
    },
    {
        name: 'destinationAirportsIataCode',
        filterType: FilterType.Array,
        componentName: 'List',
        labelKey: 'TO',
    },
    {
        name: 'tempRange',
        filterType: FilterType.Array,
        labelKey: 'TEMP',
    },
    {
        name: 'additionalFeesValidTo',
        filterType: SkyNetDataGridFilterType.TimeLessDateRange,
        componentName: 'LaneDateEnriched',
        labelKey: 'ADDITIONAL_FEES_VALID_TO',
    },
    {
        name: 'laneFeesValidTo',
        filterType: SkyNetDataGridFilterType.TimeLessDateRange,
        componentName: 'LaneDateEnriched',
        labelKey: 'LANE_FEES_VALID_TO',
    },
]

export default config
